import React from 'react';

import SelectionIndicator from 'components/selection-indicator';
import { formatDataQaIds } from 'utils/';

/** @deprecated use RadioButton from '@rbilabs/components-library' instead */
class RadioButton extends React.Component {
  render() {
    const {
      option,
      checked,
      disabled,
      inputName,
      onChange,
      size,
      defaultValue,
      uiPattern,
      hideInput,
      'data-testid': dataQaId,
      className,
    } = this.props;

    return (
      <div data-testid={`picker-option-${formatDataQaIds(dataQaId)}`} className={className}>
        <SelectionIndicator
          type="radio"
          name={option.name?.locale}
          inputName={inputName}
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          defaultValue={defaultValue}
          size={size}
          uiPattern={uiPattern}
          hideInput={hideInput}
        />
      </div>
    );
  }
}

export default RadioButton;
